import { getOffset } from "../helpers/html-utils";

interface GridSwitchysDoInterface {
  sideheight: number;
  removed: HTMLElement[];
}

// This object has to deal with the grid elements than can switch from the side to the content part of it
export default class GridSwitchys {
  private switchys: HTMLElement[];
  private grid: HTMLElement;
  private done: boolean;

  constructor(elements: HTMLElement[], grid: HTMLElement) {
    this.switchys = elements;
    this.grid = grid;
  }
  /**
   * This function choose if an element must be on the side part or on the content part of the grid
   */
  do(startHeight?: number): GridSwitchysDoInterface {
    // this.grid meaning the right part of the page where there is suppose to be the larger amount of content)
    // takes the height of this part or arg
    let result = startHeight || getOffset(this.grid).height;
    // only do it once
    this.done = true;
    //gridheight = height of the side column (shoudn't be named gridheight but whatever)
    // we add the height of each element which can switch side (i.e. element(s) that have the grid-switch attribute)
    // cannot take the height of the side div container because elements inside are in absolute position
    let gridHeight = 0;
    for (let i = 0; i < this.switchys.length; i++) {
      gridHeight += getOffset(this.switchys[i]).height;
    }
    //add other side block to the math
    const sideblock = this.grid.querySelectorAll(
      ".side:not([data-grid-switch])"
    );
    for (let j = 0; j < sideblock.length; j++) {
      gridHeight += getOffset(sideblock[j]).height;
    }
    // a pointer to iterate through the element, starting by the end of the array
    let pointer = this.switchys.length - 1;
    // an array to keep the elements that have been moved
    const removed: HTMLElement[] = [];
    // tell if the removed element is paired with something on the content part, true means a complete line
    let removedPair: any;
    // if the right part is lower than the left part and if there is enough elements to move, move the first and check again
    while (result < gridHeight && pointer > -1) {
      // get the height of the current child in order to remove it from the side height
      // take sheet as one component
      const child = [];
      const startChild = this.switchys[pointer];
      child.push(startChild);
      // calculate the sheet, must be refactored later because we already have a calculation before in the process
      if (startChild.classList.contains("sheet")) {
        // check if it's already endsheet
        if (startChild.classList.contains("endsheet")) {
          if (startChild.classList.contains("cut")) {
            child.push(startChild.nextElementSibling);
          }
        } else {
          let next = startChild.nextElementSibling;
          while (!next.classList.contains("endsheet")) {
            child.push(next);
            next = next.nextElementSibling;
          }
          child.push(next);
          // if we are on the first element of a cut row
          if (next.classList.contains("cut")) {
            child.push(next.nextElementSibling);
          }
        }
      }
      const firstH = getOffset(child[0]);
      const lastH = getOffset(child[child.length - 1]);
      const childHeight = lastH.bottom - firstH.top;
      // don't forget to add the margin, it should be better in in a variable
      result -= childHeight + 30;
      // check the pairing status
      if (child.length == 1) {
        if (removedPair) {
          if (removedPair.classList.contains("cut")) {
            this.cutCuttable(removedPair);
          }
          removedPair = undefined;
        } else {
          removedPair = child[0].classList.contains("cut") ? child[0] : false;
        }
      } else {
        removedPair = undefined;
      }
      // register the removed element and reset it as a content element
      for (let i = 0; i < child.length; i++) {
        removed.push(<HTMLElement>child[i]);
        child[i].classList.remove("side");
        child[i].classList.add("content");
        child[i].removeAttribute("style");
        child[i].removeAttribute("data-grid-switch");
        child[i].removeAttribute("data-grid-stack");
        child[i].removeAttribute("data-grid-stick");
      }
      pointer--;
    }
    // result can be lower than 0 if there is no more element on the sidebar (we have remove one margin with the last one)
    if (removedPair) {
      this.cutCuttable(removedPair);
    }
    result = result > 0 ? result : 0;
    return { sideheight: result, removed: removed };
  }
  cutCuttable(paired: HTMLElement): void {
    // search if there is a cuttable object at the last position of the grid
    const cuttable = this.grid.querySelectorAll(".content");
    let pointer = 1;
    let cuttableItem: Element;
    if (cuttable.length && cuttable[cuttable.length - 1] == paired) {
      pointer = 2;
    }
    if (
      cuttable.length >= pointer &&
      cuttable[cuttable.length - pointer].hasAttribute("data-grid-cuttable")
    ) {
      cuttableItem = cuttable[cuttable.length - pointer];
      cuttableItem.classList.add("cut");
      cuttableItem.classList.remove("cl10");
      cuttableItem.classList.remove("cl6");
      cuttableItem.classList.remove("stronglight");
      cuttableItem.classList.remove("hardlight");
      cuttableItem.classList.remove("highlight");
      const ncl = cuttableItem.getAttribute("data-grid-cuttable");
      if (ncl && ncl.length) {
        const nclSplitted = ncl.split(" ");
        for (let i = 0; i < ncl.length; i++) {
          cuttableItem.classList.add(nclSplitted[i]);
        }
      }
    }
  }
}
